import { render, staticRenderFns } from "./SubcontractGoodReceiptSuggestionDetailUpload.vue?vue&type=template&id=6f1f6476&"
import script from "./SubcontractGoodReceiptSuggestionDetailUpload.vue?vue&type=script&lang=js&"
export * from "./SubcontractGoodReceiptSuggestionDetailUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports